import { carrieUser } from '../components/demo/data/1-carrie/carrieUsers'
import { tedUser } from '../components/demo/data/2-ted/tedUsers'
import { hermioneUser } from '../components/demo/data/3-hermione/hermioneUsers'
import { ronUser } from '../components/demo/data/4-ron/ronUsers'
import { mirandaUser } from '../components/demo/data/5-miranda/mirandaUsers'
import { georgeUser } from '../components/demo/data/6-george/georgeUsers'
import { charlotteUser } from '../components/demo/data/7-charlotte/charlotteUsers'
import { leonUser } from '../components/demo/data/8-leon/leonUsers'
import { elaineUser } from '../components/demo/data/9-elaine/elaineUsers'
import { harryUser } from '../components/demo/data/10-harry/harryUsers'
import { robinSUser } from '../components/demo/data/11-robin-s/robinUsers'
import { barneyUser } from '../components/demo/data/12-barney/barneyUsers'
import { larryUser } from '../components/demo/data/14-larry/larryUsers'
import { samanthaUser } from '../components/demo/data/15-samantha/samanthaUsers'
import { kramerUser } from '../components/demo/data/16-kramer/kramerUsers'
import { gatsbyUser } from '../components/demo/data/18-gatsby/gatsbyUsers'
import { rachelUser } from '../components/demo/data/19-rachel/rachelUsers'
import { frodoUser } from '../components/demo/data/20-frodo/frodoUsers'
import { hollyUser } from '../components/demo/data/21-holly/hollyUsers'
import { monicaUser } from '../components/demo/data/23-monica/monicaUsers'
import { luigiUser } from '../components/demo/data/24-luigi/luigiUsers'
import { dumbledoreUser } from '../components/demo/data/25-dumbledore/dumbledoreUsers'
import { capitalizeFirstLetter, isMobile } from './globalHelpers'
import { AspectRatio } from '@mui/icons-material'
import { getPayload } from './storage'

// Variable Defaults

// Payload
const payload = getPayload()

// Payments
export const showPayments = true

// Video
export const acceptsVideo = false

// Colors
export const swipelyticsTurquoise = '#00ffff' // Swipelytics Turqoise
export const swipelyticsPink = '#f06292' // Swipelytics Pink
export const navbarBgDefaultColor = '#000000' // black

// Media
export const profPicDefaultURL = 'https://swipelytics-bizops-images.s3.amazonaws.com/seed-profpic-default-2.jpg'
export const uploadImageDimension = 900
export const videoThumbnailDimension = 400
export const videoDimension = 400
export const videoThumbnailTime = 0.01
export const videoFramesPerSecond = 30
// export const pinturaVideoBitrate = 850000 // 0.85MBps
export const pinturaVideoBitrate = 1250000 // 1.25MBps
export const pinturaAudioBitrate = 192000 // 192KBps
// export const maximumMediaSize = 50000000 // 50MB
export const maximumMediaSize = isMobile() ? 50000000 : 100000000 //50MB on mobile vs 100MB
export const maximumCroppedMediaSize = 10000000 //10MB
export const maximumVideoDuration = isMobile() ? 15 : 15 // 15 seconds on mobile, 15 seconds on desktop


// Widths and Heights
export const navbarHeight = '70px' //Height for the navigation bar
export const dashboardNavbarHeight = '65px' //Height of the navbar inside the estate
export const footerHeight = '150px' //Height for the footer bar
export const positionChangeHeightSm = 700
export const positionChangeWidthSm = 600
export const positionChangeWidthMd = 900
export const positionChangeWidthLg = 1200
export const priceCardWidth = 250
export const tooltipMinWidth = '225px'
export const tooltipInfoDimension = '25px'
export const iconImageDimension = '115px'
export const privacyPolicyMaxWidth = '600px'
export const testProductImageDimension = '125px'
export const hingeProfileImageDimension = (width) => {
  return width < 280 ? '245px' : width < 350 ? '315px' : width < 450 ? '360px' : width < 600 ? '360px' : width < 800 ? '360px' : '360px'
}
export const bumbleProfileImageWidth = (width) => {
  return width < 280 ? '245px' : width < 350 ? '315px' : width < 450 ? '360px' : width < 600 ? '360px' : width < 800 ? '360px' : '360px'
}
export const bumbleLeadImageHeight = (width) => {
  return ((parseInt(bumbleProfileImageWidth(width)) * 16) / 9)
}
export const bumbleImageHeight = (width) => {
  return ((parseInt(bumbleProfileImageWidth(width)) * 12) / 9)
}
export const tinderProfileImageWidth = (width) => {
  return width < 280 ? '245px' : width < 350 ? '315px' : width < 450 ? '360px' : width < 600 ? '360px' : width < 800 ? '360px' : '360px'
}

export const tinderProfileImageIndicatorWidth = (width, numberOfMediaItems) => {
  return numberOfMediaItems > 1 ? ((parseInt(tinderProfileImageWidth(width)) - 20 - ((numberOfMediaItems - 1) * 4)) / numberOfMediaItems) : 0
}
export const tinderLeadImageHeight = (width) => {
  return ((parseInt(tinderProfileImageWidth(width)) * 16) / 9)
}
export const tinderImageHeight = (width) => {
  return ((parseInt(tinderProfileImageWidth(width)) * 12) / 9)
}

export const selectMediaItemDimension = (width) => {
  return width < 300 ? '50px' : width < 330 ? '55px' : width < 350 ? '65px' : width < 400 ? '75px' : width < 450 ? '85px' : width < 500 ? '100px' : width < 600 ? '120px' : '135px'
}

// Profile Requirements
export const minimumOnboardingMedia = 6
export const maximumMediaItems = 50
export const minimumOnboardingPrompts = 0
export const minimumOnboardingAboutMe = 0
export const minimumOnboardingHobbies = 0
export const requiredVitalInfoArray = ['firstName', 'age', 'gender', 'interestedIn', 'heightInches']
export const requiredVitalInfoString = requiredVitalInfoArray.map(requiredVitalInfoKey => requiredVitalInfoKey === 'firstName' ? 'first name' : requiredVitalInfoKey === 'interestedIn' ? `'interested in'` : requiredVitalInfoKey === 'heightInches' ? 'and height' : requiredVitalInfoKey).join(', ')
export const newProfileRequirementsChecklist = [
  
  {
    toDo: 'Add Vital Info',
    // description: `In the 'Bio' tab, add the required Vital Info to your bio. (first name, age, gender, 'interested in', and height)`,
    // description: `In the 'Bio' tab, add the required Vital Info to your bio. (${requiredVitalInfoString})`,
    description: `Add the required Vital Info to your bio.`,
    // description: ``,
    // description: ``,
    videoURL: '',
    writtenInstructions: 
    `1) Navigate to the 'Bio' tab on your Dashboard.
      2) Scroll to the 'Vital Info' section.
      3) Add at least a ${requiredVitalInfoString}.
      4) Press 'Save' at the bottom of the Vital Info section.`,
  }
  ,
  {
    toDo: 'Add Media',
    // description: `In the 'Media' tab, add at least ${minimumOnboardingMedia} images or videos.`,
    description: `Add at least ${minimumOnboardingMedia} images or videos.`,
    // description: ``,
    videoURL: '',
    writtenInstructions: 
    `1) Navigate to the 'Media' tab in your Dashboard.
      2) Click 'Add Media' to add an item, or click the pencil icon next to an item to edit an existing item.
      3) Select the items you want to add (and make sure the items meet the media guidelines).
      4) Click the pencil icon on the media item to add captions and subcaptions for the item.`,
  }
  ,
  {
    toDo: 'Add Prompts and Responses',
    // description: `In the 'Bio' tab, add at least ${minimumOnboardingPrompts} Prompts and Responses`,
    description: `Add at least ${minimumOnboardingPrompts} Prompts and Responses`,
    // description: ``,
    videoURL: '',
    writtenInstructions: 
    `1) Navigate to the 'Bio' tab on your Dashboard.
      2) Scroll to the 'Prompts' section.
      3) Add at least three prompt and response pairings.
      4) Press 'Save' at the bottom of the Prompts section.`,
  }
  // ,
  // {
  //   toDo: 'Add About Me',
  //   description: `In the 'Bio' tab, add at least ${minimumOnboardingAboutMe}  'About Me' description`,
  //   // description: ``,
  //   videoURL: '',
  //   writtenInstructions: 
  //   `1) Navigate to the 'Bio' tab on your Dashboard.
  //     2) Scroll to the 'About Me' section.
  //     3) Add at least one description of yourself.
  //     4) Press 'Save' at the bottom of the About Me section.`,
  // },
  // {
  //   toDo: 'Add Hobbies/Interests',
  //   description: `In the 'Bio' tab, add at least ${minimumOnboardingHobbies} Hobbies/Interests`,
  //   // description: ``,
  //   videoURL: '',
  //   writtenInstructions: 
  //   `1) Navigate to the 'Bio' tab on your Dashboard.
  //     2) Scroll to the 'Hobbies' section.
  //     3) Add at least five hobbies or interests.
  //     4) Press 'Save' at the bottom of the Hobbies section.`,
  // }
]

export const minimumHingeMedia = 4
export const minimumHingePrompts = 0
export const minimumHingeAboutMe = 0
export const minimumHingeHobbies = 0

export const minimumBumbleMedia = 4
export const minimumBumblePrompts = 0
export const minimumBumbleAboutMe = 0
export const minimumBumbleHobbies = 0

export const minimumTinderMedia = 2
export const minimumTinderPrompts = 0
export const minimumTinderAboutMe = 0
export const minimumTinderHobbies = 0

// Hinge UI
export const hingeProfileBackgroundColor = '#F8F8F8' // Light Gray
export const hingeProfileItemBorderColor = '#F0F0F0' // Slightly darker gray
export const hingeProfileItemDividerOpacity = .7
export const hingeProfileItemBoxShadow = .75
export const hingeProfileItemBorderWidth = .25
export const hingeProfileItemBorderRadius = '10px'

// Bumble UI
export const bumbleProfileBackgroundColor = '#F8F8F8' // Light Gray
export const bumbleProfileItemBorderColor = '#F0F0F0' // Slightly darker gray
export const bumbleProfilePromptTextColor = 'dimgray'
export const bumbleProfileItemDividerOpacity = .7
export const bumbleProfileItemBoxShadow = .75
export const bumbleProfileItemBorderWidth = 0
export const bumbleProfileItemBorderRadius = '20px'


// Tinder UI
export const tinderProfileBackgroundColor = 'black'
export const tinderProfileItemBackgroundColor = '#282828' // Close to black
export const tinderProfileItemBorderColor = 'gainsboro'
export const tinderProfileTextColor = 'white'
export const tinderProfilePromptTextColor = 'whitesmoke'
export const tinderProfileItemDividerOpacity = .7
export const tinderProfileItemBoxShadow = .75
export const tinderProfileItemBorderWidth = 0
export const tinderProfileItemBorderRadius = '10px'

// Scorecard
export const scorecardPointsObj = {
  media: {
    very: 3,
    yes: 1,
    somewhat: -1,
    no: -5,
  },
  aboutMe: {
    very: 1,
    yes: 1,
    somewhat: -1,
    no: -2,
  },
  prompts: {
    very: 2,
    yes: 1,
    somewhat: -1,
    no: -3,
  },
  vitalInfo: {
    very: 2,
    yes: 1,
    somewhat: -1,
    no: -3,
  },
}

// Timers

// Arrays

// Nav menu when logged in
export const navMenuOptionsLoggedIn = [
  'Dashboard', 
  'Settings',
  // 'Create Estate',
  // 'About',
  // 'Pricing',
  // 'Demo',
  'Logout'
]

// Nav menu when not logged in
export const navMenuOptionsNotLoggedIn = [
  // 'Create Account',
  'Sign Up Free',
  // 'About',
  // 'Pricing',
  'Demo',
  'Login'
]

// Demo Users
export const demoUsersArray = [
  { ...tedUser },
  { ...carrieUser },
  { ...hermioneUser },
  { ...ronUser },
  { ...harryUser },
  { ...dumbledoreUser },
  { ...mirandaUser },
  { ...georgeUser },
  { ...leonUser },
  { ...robinSUser },
  { ...gatsbyUser },
  { ...rachelUser },
  { ...charlotteUser },
  { ...elaineUser },
  { ...barneyUser },
  { ...larryUser },
  { ...samanthaUser },
  { ...kramerUser },
  { ...frodoUser },
  { ...hollyUser },
  { ...monicaUser },
  { ...luigiUser }
]

// Sort By Arrays
export const profilesSortByArray = [
  'Date ⬇',
  'Date ⬆'
  // 'A ➡ Z',
  // 'Z ➡ A'
]
export const mediaSortByArray = [
  'Date ⬇',
  'Date ⬆',
  'Year ⬇',
  'Year ⬆',
  'My Rating ⬇',
  'My Rating ⬆'
]

export const dateRangesArray = [
  'All',
  'Last 30 Days',
  'Last 6 Months',
  'Last Year'
]

export const profileTypes = [
  'Hinge',
  'Bumble',
  'Tinder'
]

export const profileVibes = [
  'Active',
  'Artistic',
  'Casual',
  'Classy',
  'Epic',
  'Exciting',
  'Free-spirited',
  'Fun',
  'Glamorous',
  'Mysterious',
  'Open-minded',
  'Philosophical',
  'Relaxed',
  'Sexy',
  'Social',
  'Smart',
  'Sporty',
  'Successful'
]

export const profileStatuses = [
  'All Profiles',
  'Incomplete Profiles',
  'Completed Profiles'
]

export const mediaMinDatesArray = [
  'All',
  'Last 5 Years',
  'Last 3 Years',
  'Last 1 Year'
]

export const mediaTypesArray = [
  'All',
  'Images',
  'Videos'
]


// Stepper Defaults
export const ministepsHeight = '25px' // Height for the ministep elements in onboarding process
export const bottomSteps = minimumOnboardingPrompts > 0 || minimumOnboardingAboutMe > 0 || minimumOnboardingHobbies > 0 
  ?
  [
    'Vitals', 
    'Media', 
    'Bio'
  ] // Bottom Steps for Onboarding Process including Bio
  :
  [
    'Vitals', 
    'Media'
  ] // Bottom Steps for Onboarding Process NOT including Bio

// Media Guidelines
export const cropAspectRatiosArray = [
  {
    aspectRatio: 1 / 1,
    text: 'square',
  },
  {
    aspectRatio: 3 / 4,
    text: 'portrait',
  }
]
// export const mediaGuidelinesString = `*Images and short videos
//         *Upload at least ${minimumOnboardingMedia} and up to ${maximumMediaItems}
//         *Files must be less than 10MB
//         *Videos MUST BE less than ${maximumVideoDuration} seconds
//         *Videos MUST BE square (1:1)`.replace(/ {5} +/g, '')
// export const mediaGuidelinesString = `*Images and short videos
//         *Videos MUST BE less than ${maximumVideoDuration} seconds
//         *Files must be less than ${maximumMediaSize / 1000000}MB`.replace(/ {5} +/g, '')
export const mediaGuidelinesString = `*images/short videos
        *Files must be less than ${Math.round((maximumMediaSize / 1000000) * .8)}MB
        **Screenshot images from your current dating profile if it's tough to find the originals`.replace(/ {5} +/g, '')
// export const mediaGuidelinesString = `*Images and short videos
//         *Upload at least 6 and up to 50`.replace(/ {5} +/g, '')

// export const mediaGuidelinesHTML = `
//   <p>*Images and short videos</p>
//   <p>*Upload at least ${minimumOnboardingMedia} and up to ${maximumMediaItems}</p>
//   <p>*Files must be less than 10MB</p>
//   <p>*Videos MUST BE less than ${maximumVideoDuration} seconds</p>
//   <p>*Videos MUST BE square (1:1)</p>
// `
// export const mediaGuidelinesHTML = `
//   <p>*Images and short videos</p>
//   <p>*Videos MUST BE less than ${maximumVideoDuration} seconds</p>
//   <p>*Files must be less than ${maximumMediaSize / 1000000}MB</p>
// `
export const mediaGuidelinesHTML = `
  <p>*Images and short videos</p>
  <p>*Files must be less than ${Math.round((maximumMediaSize / 1000000) * .8)}MB</p>
`
// export const mediaGuidelinesHTML = `
//   <p>*Images and short videos</p>
//   <p>*Upload at least ${minimumOnboardingMedia} and up to ${maximumMediaItems}</p>
// `

// Rates
export const monthlyRate = 12
export const yearlyRate = 3000
export const oneTimeRate = 300
export const aiReviewRate = 10
export const aiReviewDiscount = process.env.REACT_APP_CLIENT_URL === 'http://localhost:3000' ? 0 
  : (payload && 'sub' in payload && payload.sub.length > 0 && payload.sub.toString() === process.env.REACT_APP_ADMIN_USER_ID) ? 0
    : 0.5
export const expertReviewRate = 50
export const expertReviewDiscount = process.env.REACT_APP_CLIENT_URL === 'http://localhost:3000' ? 0 : .6
export const maxExpertReviewRate = 1000
export const friendReviewRate = 5
export const friendReviewDiscount = 0

export const reviewTypeOptionsArray = [
  {
    type: 'Expert',
    fullPrice: parseFloat(expertReviewRate),
    price: parseFloat(expertReviewRate * expertReviewDiscount),
    duration: '24 hrs',
    tooltip: `
      <span style="font-weight:bold; color:${swipelyticsTurquoise};">Expert</span>
      <br/>
      — Done by a human expert.
      <br/>
      — Usually completed within <b>24 hours</b>. 
    `,
  },
  {
    type: 'Friend',
    fullPrice: parseFloat(friendReviewRate),
    price: parseFloat(friendReviewRate * friendReviewDiscount),
    duration: 'How prompt is your friend?',
    tooltip: `
      <span style="font-weight:bold; color:${swipelyticsTurquoise};">Friend</span>
      <br/>
      — Get the opinions of people you trust.
    `,
  },
  {
    type: 'AI',
    fullPrice: parseFloat(aiReviewRate),
    price: parseFloat(aiReviewRate * aiReviewDiscount),
    duration: '5 min',
    tooltip: `
      <span style="font-weight:bold; color:${swipelyticsTurquoise};">AI</span>
      <br/>
      — Done by an AI assistant.
      <br/>
      — Usually completed within <b>5 minutes</b>. 
    `,
  }
]

// Subscription Types
export const subscriptionTypes = [
  {
    interval: 'one-time',
    rate: oneTimeRate,
    simulations: '10',
    freeTrial: false,
  },
  {
    interval: 'month',
    rate: monthlyRate,
    freeTrial: true,
  },
  {
    interval: 'year',
    rate: yearlyRate,
    simulations: 'Unlimited',
    freeTrial: true,
  }
]

// Onboarding 
// Ages (18 — 99)
export const agesArray = Array.from({ length: 82 },(v,k)=>k + 18)

// Genders
export const gendersArray = [
  'Male',
  'Female',
  'Non-binary'
]

// Pronouns
export const pronounsArray = [
  'she/her',
  'he/him',
  'she/them',
  'he/them',
  'he/her',
  'she/him',
  'they/them',
  'they/her',
  'they/him',
  'Not listed',
  'Prefer not to say'
]

// Sexuality
export const sexualitiesArray = [
  'Straight',
  'Gay',
  'Lesbian',
  'Bisexual',
  'Allosexual',
  'Androsexual',
  'Asexual',
  'Autosexual',
  'Demisexual',
  'Fluid',
  'Graysexual',
  'Gynesexual',
  'Monosexual',
  'Omnisexual',
  'Pansexual',
  'Polysexual',
  'Queer',
  'Questioning',
  'Skoliosexual',
  'Spectrasexual',
  'Not Listed'
]

// Interested In
export const interestedInArray = [
  'Men',
  'Women',
  'Non-binary People',
  'Everyone'
]

// Height (Inches)
export const heightInchesArray = Array.from({ length: 43 },(v,k)=>k + 48)

// Height (CM)
export const heightCMsArray = Array.from({ length: 111 },(v,k)=>k + 120)

// Years
export const yearsArray = Array.from({ length: (new Date().getFullYear() - 1960 + 1) },(v,k)=>k + 1960).reverse()

// Personal Ratings
export const personalRatingsArray = Array.from({ length: 11 },(v,k)=> k)

// Religion 
export const religionsArray = [
  'Agnostic',
  'Atheist',
  'Buddhist',
  'Catholic',
  'Christian',
  'Hindu',
  'Jewish',
  'Muslim',
  'Sikh',
  'Spiritual',
  'Other',
  'Prefer not to say'
]

// Politics
export const politicsArray = [
  'Liberal',
  'Moderate',
  'Conservative',
  'Not Political',
  'Other',
  'Prefer not to say'
]

// Ethnicity
export const ethnicitiesArray = [
  'Black/African Descent',
  'East Asian',
  'Hispanic/Latino',
  'Middle Eastern',
  'Native American',
  'Pacific Islander',
  'South Asian',
  'Southeast Asian',
  'White/Caucasian',
  'Other',
  'Prefer not to say'
]

// Education Levels
export const educationLevelsArray = [
  'High School',
  'Undergrad',
  'Postgrad',
  'Prefer not to say'
]

// Children
export const childrenArray = [
  `Don't have children`,
  'Have children',
  'Prefer not to say'
]

// Family Plans
export const familyPlansArray = [
  `Don't want children`,
  'Want children',
  'Open to children',
  'Not sure',
  'Prefer not to say'
]

// Alcohol
export const alcoholArray = [
  'Yes',
  'Sometimes',
  'No',
  'Sober',
  'Prefer not to say'
]

// Cigarettes
export const cigarettesArray = [
  'Yes',
  'Sometimes',
  'No',
  'Prefer not to say'
]

// Weed
export const weedArray = [
  'Yes',
  'Sometimes',
  'No',
  'Prefer not to say'
]

// Drugs
export const drugsArray = [
  'Yes',
  'Sometimes',
  'No',
  'Prefer not to say'
]

// Pets
export const petsArray = [
  'Dog',
  'Cat',
  'Bird',
  'Fish',
  'Reptile',
  'None',
  'Prefer not to say'
]

// Zociac Signs
export const zodiacSignsArray = [
  'Aries',
  'Taurus',
  'Gemini',
  'Cancer',
  'Leo',
  'Virgo',
  'Libra',
  'Scorpio',
  'Sagittarius',
  'Capricorn',
  'Aquarius',
  'Pisces',
  'Prefer not to say'
]

// Relationship Type
export const relationshipTypesArray = [
  'Monogamy',
  'Non-monogamy',
  'Figuring out my relationship type',
  'Prefer not to say'
]

// Dating Intentions
export const datingIntentionsArray = [
  'Life partner',
  'Long-term relationship',
  'Long-term relationship, open to short',
  'Short-term relationship, open to long',
  'Short-term relationship',
  'Figuring out my dating goals',
  'Prefer not to say'
]

export const promptsArray = [
  `Unusual skills`,
  `I'm convinced that`,
  `My best Dad Joke`,
  `Typical Sunday`,
  `A random fact I love is`,
  `This year, I really want to`,
  `My most irrational fear`,
  `I go crazy for`,
  `A life goal of mine`,
  `My simple pleasures`,
  `My greatest strength`,
  `The way to win me over is`,
  `Dating me is like`,
  `I recently discovered that`,
  `Best travel story`,
  `Most spontaneous thing I've done`,
  `Never have I ever`,
  `Two truths and a lie`,
  `My biggest date fail`,
  `Worst idea I've ever had`,
  `One thing I'll never do again`,
  `Weirdest gift I have ever given or received`,
  `Biggest risk I've taken`,
  `Together, we could`,
  `First round is on me if`,
  `What I order for the table`,
  `The best way to ask me out is by`,
  `I know the best spot in town for`,
  `I'll pick the topic, you pick the conversation`,
  `You should leave a comment if`,
  `Let's debate this topic`,
  `I bet you can't`,
  `Let's make sure we're on the same page about`,
  `Change my mind about`,
  `The one thing I'd love to know about you is`,
  `Do you agree or disagree that`,
  `Teach me something about`,
  `Try to guess this about me`,
  `Give me travel tips for`,
  `You should *not* go out with me if`,
  `If loving this is wrong, I don't want to be right`,
  `The dorkiest thing about me is`,
  `I geek out on`,
  `The one thing you should know about me is`,
  `My Love Language is`,
  `My most controversial opinion is`,
  `The key to my heart is`,
  `Don't hate me if I`,
  `What if I told you that`,
  `I won't shut up about`,
  `The last time I cried happy tears was`,
  `A boundary of mine is`,
  `My cry-in-the-car song is`,
  `Therapy recently taught me`,
  `My self-care routine is`,
  `I feel most supported when`,
  `I wind down by`,
  `To me, relaxation is`,
  `My therapist would say I`,
  `My friends ask me for advice about`,
  `I hype myself up by`,
  `My last journal entry was about`,
  `When I need advice, I go to`,
  `I get myself out of a funk by`,
  `I'll give you the set up, you guess the punchline`,
  `My favorite line from a movie`,
  `How to pronounce my name`,
  `I wish more people knew`,
  `A shower thought I recently had`,
  `Guess the song`,
  `My BFF's take on why you should date me`,
  `A quick rant about`,
  `Saying 'Hi!' in as many languages as I know`,
  `Proof that I have musical talent`,
  `My best celebrity impression`,
  `Apparently, my life's soundtrack is`,
  `I'm looking for`,
  `All I ask is that you`,
  `We're the same type of weird if`,
  `I'll brag about you to my friends if`,
  `I'm weirdly attracted to`,
  `I'll fall for you if`,
  `We'll get along if`,
  `Green flags I look for`,
  `The hallmark of a good relationship is`,
  `I want someone who`,
  `Something that's non-negotiable for me is`
]

// Captions Array
export const captionsArray = [
  `No Caption`,
  `Woke up like this`,
  `Get someone who looks at you like`,
  `Post-coffee me`,
  `Who wore it better?`,
  `My best blue steel`,
  `It's all about the simple things`,
  `This could be us`,
  `I can teach you how to`,
  `Lowkey flex`,
  `I thought I deleted this one`,
  `Take me back to`,
  `My vulnerable side`,
  `#MondaysAmIRight?`,
  `Life outtake`,
  `My good side`,
  `My quarter life crisis looks like`,
  `Don't show this to my mom`,
  `Write the subtitles for this video`,
  `My submission to National Geographic`,
  `Thank you for coming to my TED Talk`,
  `Me and my best friend`,
  `A special talent of mine`,
  `The moment I knew my modeling career was over`,
  `I'm known for`,
  `My proudest moment`,
  `Caption this photo`,
  `That one dance trend I nailed`,
  `You had to be there`,
  `Guess the backstory of this photo`,
  `How history will remember me`,
  `Felt cute might delete later`,
  `Are you a cat person because...`,
  `My life peaked when`,
  `It was all fun and games until`,
  `Video most likely to win an Oscar`,
  `Selfie #503`,
  `My dog looks at me like this`,
  `How I fight the Sunday scaries`,
  `Dating me will look like`,
  `This year, I really want to`,
  `Leave a comment if you want to meet here`,
  `Leave a one-word review for this`,
  `Let me introduce you to my alter ego`,
  `My weekends look like`,
  `I'm learning how to`,
  `Pre-coffee me`,
  `This should go viral`,
  `My life behind the scenes`,
  `The advertisement for my life would look like`,
  `Comment if you've been here`,
  `A favorite memory of mine`,
  `Guess where this photo was taken`,
  `Me in the wild`,
  `Plandid or candid?`,
  `Most exotic place I've been`,
  `Help me identify this photo bomber`,
  `As seen on my Mom's fridge`,
  `My Instagram Story mostly contains`,
  `Let's do this for our date from home`,
  `Never have I ever`,
  `My favorite thing to do while social distancing`,
  `Guess how many takes this took`,
  `How my friends see me`,
  `Found in my 90s time capsule`,
  `Don't judge me`,
  `Are you a dog person because`,
  `My funniest home video submission`,
  `I feel famous when`,
  `Biggest risk I've ever taken`,
  `Together we could be terrible at`,
  `Me during Fashion Week`,
  `My uniform`,
  `Me in my blogging days`,
  `Caught in the act`
]

// Languages
export const languagesArray = [
  'Arabic',
  'Cantonese',
  'English',
  'French',
  'German',
  'Japanese',
  'Korean',
  'Mandarin',
  'Persian',
  'Portuguese',
  'Russian',
  'Spanish',
  'Urdu',
  'Afrikaans',
  'Albanian',
  'American Sign Language',
  'Amharic',
  // 'Arabic',
  'Armenian',
  'Assamese',
  'Auslan',
  'Austrian Sign Language',
  'Aymara',
  'Azerbaijani',
  'Bambara',
  'Basque',
  'Belarusian',
  'Bengali',
  'Bhojpuri',
  'Black American Sign Language',
  'Bosnian',
  'British Sign Language',
  'Bulgarian',
  'Catalan',
  'Cebuano',
  'Chichewa',
  'Corsican',
  'Croatian',
  'Czech',
  'Danish',
  'Dhivehi',
  'Dogri',
  'Dutch',
  // 'English',
  'Esperanto',
  'Estonian',
  'Ewe',
  'Filipino',
  'Finnish',
  // 'French',
  'French Sign Language',
  'Frisian',
  'Galician',
  'Georgian',
  // 'German',
  'German Sign Language',
  'Greek',
  'Guarani',
  'Gujarati',
  'Haitian Creole',
  'Hausa',
  'Hawaiian',
  'Hebrew',
  'Hindi',
  'Hmong',
  'Hungarian',
  'Icelandic',
  'Igbo',
  'Ilocano',
  'Indonesian',
  'Irish',
  'Italian',
  'Italian Sign Language',
  // 'Japanese',
  'Javanese',
  'Kannada',
  'Kazakh',
  'Khmer',
  'Kinyarwanda',
  'Klingon',
  'Konkani',
  // 'Korean',
  'Krio',
  'Kurdish',
  'Kyrgyz',
  'Lao',
  'Latin',
  'Latvian',
  'Lingala',
  'Lithuanian',
  'Luganda',
  'Luxembourgish',
  'Macedonian',
  'Maithili',
  'Malagasy',
  'Malay',
  'Maltese',
  // 'Mandarin Chinese',
  'Maori',
  'Marathi',
  'Meiteilon (Manipuri)',
  'Mizo',
  'Mongolian',
  'Myanmar (Burmese)',
  'Nepali',
  'Norwegian',
  'Odia (Oriya)',
  'Oromo',
  'Pashto',
  // 'Persian',
  'Polish',
  // 'Portuguese',
  'Punjabi',
  'Quechua',
  'Romanian',
  // 'Russian',
  'Samoan',
  'Sanskrit',
  'Scots Gaelic',
  'Sepedi',
  'Serbian',
  'Sesotho',
  'Shona',
  'Sindhi',
  'Sinhala',
  'Slovak',
  'Slovenian',
  'Somali',
  // 'Spanish',
  'Spanish Sign Language',
  'Sundanese',
  'Swahili',
  'Swedish',
  'Swedish Sign Language',
  'Swiss-German Sign Language',
  'Tajik',
  'Tamil',
  'Tatar',
  'Telugu',
  'Thai',
  'Tigrinya',
  'Tsonga',
  'Turkish',
  'Turkmen',
  'Twi',
  'Ukrainian',
  // 'Urdu',
  'Uyghur',
  'Uzbek',
  'Vietnamese',
  'Welsh',
  'Xhosa',
  'Yiddish',
  'Yoruba',
  // 'YueChinese (Cantonese)',
  'Zulu'
]


// Permitted Country Codes — https://www.iban.com/country-codes
export const permittedCountryCodes = [
  'US', // United States
  'FR', // France
  'AU', // Australia
  'AT', // Austria
  'BE', // Belgium
  'CA', // Canada
  'DK', // Denmark
  'FI', // Finland
  'DE', // Germany
  'GR', // Greece
  'HK', // Hong Kong
  'IE', // Ireland
  'IL', // Israel
  'IT', // Italy
  'JP', // Japan
  'LI', // Liechtenstein
  'LU', // Luxembourg
  'MX', // Mexico
  'NL', // The Netherlands
  'NZ', // New Zealand
  'NO', // Norwary
  'PL', // Poland
  'PT', // Portugal
  'PR', // Puerto Rico
  'SG', // Singapore
  'ES', // Spain
  'SE', // Sweden
  'CH', // Switzerland
  'GB', // Great Britain

  'AF', // Afghanistan
  'AL', // Albania
  'DZ', // Algeria
  'AM', // American Samoa
  'AD', // Andorra
  'AO', // Angola
  'AI', // Anguilla
  'AQ', // Antarctica
  'AG', // Antigua and Barbuda
  'AR', // Argentina
  'AM', // Armenia
  'AW', // Aruba
  'AZ', // Azerbaijan
  'BS', // The Bahamas
  'BH', // Bahrain
  'BD', // Bangladesh
  'BB', // Barbados
  'BY', // Belarus
  'BZ', // Belize
  'BJ', // Benin
  'BM', // Bermuda
  'BT', // Bhutan
  'BO', // Bolivia
  'BQ', // Bonaire
  'BA', // Bosnia and Herzegovina
  'BW', // Botswana
  'BV', // Bouvet Island
  'IO', // British Indian Ocean Territory
  'BN', // Brunei
  'BG', // Bulgaria
  'BF', // Burkina Faso
  'BI', // Burundi
  'CV', // Cabo Verde
  'KH', // Cambodia
  'CM', // Camaroon
  'KY', // the Cayman Islands
  'CF', // Central African Republic
  'TD', // Chad
  'CL', // Chile
  'CN', // China
  'CX', // Christmas Island
  'CC', // The Cocos Islands
  'CO', // Colombia
  'KM', // The Comoros
  'CD', // Democratic Republic of Congo
  'CG', // Congo
  'CK', // The Cook Islands
  'CR', // Costa Rica
  'HR', // Croatia
  'CU', // Cuba
  'CW', // Curacao
  'CY', // Cyprus
  'CZ', // Czech Republic
  'CI', // Ivory Coast
  'DJ', // Djibouti
  'DM', // Dominica
  'DO', // The Dominican Republic
  'EC', // Ecuador
  'EG', // Egypt
  'SV', // El Salvador
  'GQ', // Equatorial Guinea
  'ER', // Eritrea
  'EE', // Estonia
  'SZ', // Eswatini
  'ET', // Ethiopia
  'FK', // Falkland Islands
  'FO', // Faroe Islands
  'FJ', // Fiji
  'GF', // French Guiana
  'PF', // French Polynesia
  'TF', // French Southern Territories
  'GA', // Gabon
  'GM', // Gambia
  'GE', // Georgia
  'GH', // Ghana
  'GI', // Gibraltar
  'GL', // Greenland
  'GD', // Grenada
  'GP', // Guadeloupe
  'GU', // Guam
  'GT', // Guatemala
  'GG', // Guernsey
  'GN', // Guinea
  'GW', // Guinea-Bissau
  'GY', // Guyana
  'HT', // Haiti
  'HM', // Heard Island and McDonald Islands
  'VA', // The Holy See
  'HN', // Honduras
  'HU', // Hungary
  'IS', // Iceland
  'IN', // India
  'ID', // Indonesia
  'IR', // Iran
  'IQ', // Iraq
  'IM', // Isle of Man
  'JM', // Jamaica
  'JE', // Jersey
  'JO', // Jordan
  'KZ', // Kazakhstan
  'KE', // Kenya
  'KI', // Kiribati
  // 'KP', // North Korea
  'KR', // South Korea
  'KW', // Kuwait
  'KG', // Kyrgyzstan
  'LA', // Laos
  'LV', // Latvia
  'LB', // Lebanon
  'LS', // Lesotho
  'LR', // Liberia
  'LY', // Libya
  'LT', // Lithuania
  'MO', // Macao
  'MG', // Madagascar
  'MW', // Malawi
  'MY', // Malaysia
  'MV', // The Maldives
  'ML', // Mali
  'MT', // Malta
  'MH', // The Marshall Islands
  'MQ', // Martinique
  'MR', // Mauritania
  'MU', // Mauritius
  'YT', // Mayotte
  'FM', // Micronesia
  'MD', // Maldova
  'MC', // Monaco
  'MN', // Mongolia
  'ME', // Montenegro
  'MS', // Montserrat
  'MA', // Morocco
  'MZ', // Mozambique
  'MM', // Myanmar
  'NA', // Namibia
  'NR', // Nauru
  'NP', // Nepal
  'NC', // New Caledonia
  'NI', // Nicaragua
  'NE', // Niger
  'NG', // Nigeria
  'NU', // Niue
  'NF', // Norfolk Island
  'MP', // Northern Mariana Islands
  'OM', // Oman
  'PK', // Pakistan
  'PW', // Palau
  'PS', // Palestine
  'PA', // Panama
  'PG', // Papua New Guinea
  'PY', // Paraguay
  'PE', // Peru
  'PH', // The Philippines
  'PN', // Pitcairn
  'QA', // Qatar
  'MK', // Macedonia
  'RO', // Romania
  // 'RU', // Russia
  'RW', // Rwanda
  'RE', // Reunion
  'BL', // Saint Barthelemy
  'SH', // Saint Helena
  'KN', // Saint Kitts and Nevis
  'LC', // Saint Lucia
  'MF', // Saint Martin
  'PM', // Saint Pierre and Miquelon
  'VC', // Saint Vincent and the Grenadines
  'WS', // Samoa
  'SM', // San Marino
  'ST', // Sao Tome and Principe
  'SA', // Saudi Arabia
  'SN', // Senegal
  'RS', // Serbia
  'SC', // Seychelles
  'SL', // Sierra Leone
  'SX', // Sint Maarten
  'SK', // Slovakia
  'SI', // Slovenia
  'SB', // Solomon Islands
  'SO', // Somalia
  'ZA', // South Africa
  'GS', // South Georgia and the Sandwich Islands
  'SS', // South Sudan
  'LK', // Sri Lanka
  'SD', // Sudan
  'SR', // Suriname
  'SJ', // Svalbard
  'SY', // Syria
  'TW', // Taiwan
  'TJ', // Tajikistan
  'TZ', // Tanzania
  'TH', // Thailand
  'TL', // Timor-Leste
  'TG', // Togo
  'TK', // Tokelau
  'TO', // Tonga
  'TT', // Trinidad and Tobago
  'TN', // Tunisia
  'TR', // Turkey
  'TM', // Turkmenistan
  'TC', // Turks and Caicos
  'TV', // Tuvalu
  'UG', // Uganda
  'UA', // Ukraine
  'AE', // United Arab Emirates
  'UM', // United States Minor Outlying Islands
  'UY', // Uruguay
  'UZ', // Uzbekistan
  'VU', // Vanuatu
  'VE', // Venezuela
  'VN', // Vietnam
  'VG', // British Virgin Islands
  'VI', // US Virgin Islands
  'WF', // Wallis and Futuna
  'EH', // Western Sahara
  'YE', // Yemen
  'ZM', // Zambia
  'ZW', // Zimbabwe
  'AX', // Aland Islands
  ''
]